




























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Datasource } from '../services/datasource';
import { Machine } from '../models/machine';

@Component
export default class ListMachines extends Vue {

  @Prop() machines!: Machine[]
}
